"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreApiClient = void 0;
const commons_logs_1 = require("@deliverr/commons-logs");
const commons_objects_1 = require("@deliverr/commons-objects");
const defaultErrorHandler_1 = require("./util/defaultErrorHandler");
const getRequestTrackingInterceptor_1 = require("./util/getRequestTrackingInterceptor");
const throwIfMissingBaseUrlEnvVar_1 = require("./util/throwIfMissingBaseUrlEnvVar");
class CoreApiClient {
    constructor(receivedConfig) {
        var _a;
        this.config = receivedConfig !== null && receivedConfig !== void 0 ? receivedConfig : {};
        this.errorHandler = (_a = this.config.errorHandler) !== null && _a !== void 0 ? _a : defaultErrorHandler_1.defaultErrorHandler;
        this.authEngine = this.config.authEngine;
        let baseUrlToUse;
        if (this.config.baseURL) {
            baseUrlToUse = this.config.baseURL;
        }
        else {
            const serviceUrlEnvKeyToUse = this.config.serviceUrlEnvKey || this.getDefaultServiceUrlEnvKey();
            if (serviceUrlEnvKeyToUse) {
                baseUrlToUse = (0, throwIfMissingBaseUrlEnvVar_1.throwIfMissingBaseUrlEnvVar)(serviceUrlEnvKeyToUse);
            }
        }
        if (!baseUrlToUse) {
            throw new Error("Missing base URL");
        }
        this.config.baseURL = baseUrlToUse;
        if (this.authEngine === commons_objects_1.AuthEngine.BASIC) {
            const basicAuthConfigSupportCast = this.config;
            if (basicAuthConfigSupportCast.basicAuthUser && basicAuthConfigSupportCast.basicAuthPassword) {
                this.config.auth = {
                    username: basicAuthConfigSupportCast.basicAuthUser,
                    password: basicAuthConfigSupportCast.basicAuthPassword,
                };
            }
            else {
                throw new Error("Missing basic authentication username or password");
            }
        }
        commons_logs_1.log.debug({ baseURL: this.config.baseURL, client: this.constructor.name }, "baseURL defined");
    }
    addBeforeEach(beforeEach) {
        this.beforeEach = beforeEach;
    }
    async executeBeforeEach() {
        return this.beforeEach ? this.beforeEach() : Promise.resolve();
    }
    withAccessToken(token) {
        this.authToken = token;
        return this;
    }
    getAuthToken() {
        return this.authToken;
    }
    afterAxiosInitialized(axios) {
        if (!axios) {
            throw new Error("Received undefined axios instance parameter");
        }
        this.axios = axios;
        if (this.authEngine === commons_objects_1.AuthEngine.AUTH0) {
            this.axios.defaults.headers.common[commons_objects_1.authEngineHeader] = commons_objects_1.AuthEngine.AUTH0;
        }
        this.addAxiosRequestInterceptor();
        return this;
    }
    addAxiosRequestInterceptor() {
        if (!this.axios) {
            throw new Error("Axios instance is not initialized");
        }
        this.axios.interceptors.request.use((0, getRequestTrackingInterceptor_1.getRequestTrackingInterceptor)(this));
        return this;
    }
    async wrapClientOperationExecution(executeWork, customErrorHandler) {
        try {
            return executeWork();
        }
        catch (e) {
            if (customErrorHandler) {
                return customErrorHandler(e);
            }
            return this.errorHandler(e);
        }
    }
}
exports.CoreApiClient = CoreApiClient;
//# sourceMappingURL=CoreApiClient.js.map